import { useContext } from "react"
import { LoginForm } from "source/login/LoginForm"
import { Modal } from "source/shared/components/Modal"
import { ServerRenderedProps } from "source/shared/contexts/ServerRenderedProps"
import { formattedCents } from "source/giving/utils/money"

export function ContinueUnauthed({ totalCents }: { totalCents: number }) {
  const { login } = useContext(ServerRenderedProps)
  return (
    <Modal>
      <Modal.Show>
        <Modal.Header></Modal.Header>
        <Modal.Body>
          <LoginForm
            emailOnly={login.email_only}
            textOverrides={{
              devicePrompt: {
                phone: "Enter your phone number",
                email: "Enter your email address",
              },
              codeDescription:
                "We\u2019ll send you a code to complete your gift securely.",
              secondDevicePrompt: {
                email: "To send your receipt,",
              },
              newPersonPrompt:
                "Enter your first and last name to select your payment method.",
              confirmPerson:
                "Continue to select your payment method and complete your gift.",
            }}
          />
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal.Show>
      <Modal.Trigger className="btn">
        Continue to give{totalCents > 0 && ` ${formattedCents(totalCents)}`}
      </Modal.Trigger>
    </Modal>
  )
}
